import { render, staticRenderFns } from "./moderatorUnderReview.vue?vue&type=template&id=35241958&scoped=true"
import script from "./moderatorUnderReview.vue?vue&type=script&lang=js"
export * from "./moderatorUnderReview.vue?vue&type=script&lang=js"
import style0 from "./moderatorUnderReview.vue?vue&type=style&index=0&id=35241958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35241958",
  null
  
)

export default component.exports